import i18n from 'i18next';

/**
 * Returns the translated and uppercased label for a filter (class category).
 * @param titleClass the class category key
 * @param ns translation namespace, defaults to 'catalog'
 */
export function getLabelFromCode(
  titleClass: string,
  ns = 'catalog'
): string {
  return i18n.t(titleClass, { ns }).toUpperCase();
}

/**
 * Returns the translated and title-cased display title for a music category.
 * Words are capitalized (first letter uppercase, rest lowercase).
 * @param titleClass the class category key
 * @param ns translation namespace, defaults to 'catalog'
 */
export function getTitleFromCode(
  titleClass: string,
  ns = 'catalog'
): string {
  const translated = i18n.t(titleClass, { ns });
  return translated
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
